import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { string, func } from 'prop-types'
import { Button, Icon } from 'semantic-ui-react'
import { ChartHeader } from '../styles/SubTypeChart'
import { filterSignsBySub } from '../../../../store/Actions'
import { updateClusterColor } from '../../../../store/Actions/MapActions'

class ClearChart extends PureComponent {
  handleFilter = () => {
    this.props.filterSignsBySub('')
    this.props.updateClusterColor(null)
  }
  render() {
    return this.props.subCategory !== '' ? (
      <ChartHeader onClick={() => this.handleFilter()} title="clear filters">
        <Button icon labelPosition="left" color="blue">
          <Icon name="undo" />
          All Signs
        </Button>
      </ChartHeader>
    ) : null
  }
}

ClearChart.defaultProps = {
  subCategory: '',
}

ClearChart.propTypes = {
  subCategory: string.isRequired,
  filterSignsBySub: func.isRequired,
  theme: string.isRequired,
}

const mapStateToProps = ({ spi }) => ({
  subCategory: spi.subCategory,
  theme: spi.theme,
})

const mapDispatchToProps = dispatch => ({
  filterSignsBySub: sub => dispatch(filterSignsBySub(sub)),
  updateClusterColor: value => dispatch(updateClusterColor(value)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClearChart)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/SubTypeChart/ClearChart.jsx